import { useState } from 'react';
import { useStateMachine } from 'little-state-machine';
import { useForm } from 'react-hook-form';
import updateAction from '../updateAction';
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorMessageHandler } from '../../../../_helpers/_methods';
import styled from 'styled-components';
import { Heading4 } from '../../../../Components/FormHeading';
import { fetchWrapper } from '../../../../_helpers/fetchWrapper';
import PostEventCreatePrompt from './PostEventCreatePrompt';
import { toast } from 'react-toastify';
import NavigationButtonGroup from './components/NavigationButtonGroup';
import clearStore from '../clearStore';
import CourseAddition from './components/CourseAddition/_CourseAddition';

export const postingDataGenerator = (postingData) => {
  postingData.thematic_areas =
    typeof postingData.thematic_areas === 'string'
      ? [postingData.thematic_areas]
      : postingData.thematic_areas;
  if (postingData.mtot) {
    if (postingData.mtot[0] === 'true' || postingData.mtot === 'true') {
      postingData.mtot = true;
    } else {
      postingData.mtot = false;
    }
  } else {
    postingData.mtot = false;
  }

  let postingTargetedGovData = [];
  let targetedGov = { ...postingData.targeted_local_gov };
  let targetedProvGov = { ...postingData.targeted_prov_gov };
  let targetedDistGov = { ...postingData.targeted_dist_gov };
  let tempExpected_participant_sector = { ...postingData.expected_participant_sector };
  if (
    tempExpected_participant_sector['प्रदेश तह'] &&
    tempExpected_participant_sector['प्रदेश तह'].length > 0
  ) {
    if (targetedProvGov.province?.provinces?.length > 0) {
      let provinces = {
        type: 'प्रदेश तह',
        province: targetedProvGov.province.provinces.map((province) => province.id)
      };
      postingTargetedGovData.push(provinces);
    }
  }
  if (
    tempExpected_participant_sector['स्थानिय तह'] &&
    tempExpected_participant_sector['स्थानिय तह'].length > 0
  ) {
    if (targetedGov?.localLevel?.local_levels?.length > 0) {
      let localLevel = {
        type: 'स्थानिय तह',
        local_level: targetedGov.localLevel?.local_levels.map((localLevel) => localLevel.id)
      };
      postingTargetedGovData.push(localLevel);
    }
  }
  if (
    tempExpected_participant_sector['जिल्ला तह'] &&
    tempExpected_participant_sector['जिल्ला तह'].length > 0
  ) {
    if (targetedDistGov.district?.districts?.length > 0) {
      let districts = {
        type: 'जिल्ला तह',
        districts: targetedDistGov.district?.districts.map((district) => district.id)
      };
      postingTargetedGovData.push(districts);
    }
  }
  let newExpted_participant_sector = [];
  if (
    tempExpected_participant_sector['संघिय तह'] &&
    tempExpected_participant_sector['संघिय तह'].length > 0
  ) {
    let federal = {
      type: 'संघिय तह'
    };
    postingTargetedGovData.push(federal);
  }
  Object.values(tempExpected_participant_sector).forEach((value) => {
    if (value?.length > 0) {
      newExpted_participant_sector = [...newExpted_participant_sector, ...value];
    }
  });
  postingData.expected_participant_sector = newExpted_participant_sector;

  postingData.targeted_local_gov = postingTargetedGovData;
  console.log(postingData, 'postingData');
  if (
    postingData.nature &&
    postingData.nature.includes('physical') &&
    postingData.nature.includes('online')
  ) {
    postingData.nature = 'semi-physical';
  } else if (postingData.nature.includes('physical')) {
    postingData.nature = 'physical';
  } else if (postingData.nature.includes('online')) {
    postingData.nature = 'online';
  }
  let postingPhysicalLocationData;
  if (['physical', 'semi-physical'].includes(postingData.nature)) {
    postingPhysicalLocationData = {
      province:
        postingData.physical_location_details.province.value ||
        postingData.physical_location_details.province,
      district:
        postingData.physical_location_details.district.value ||
        postingData.physical_location_details.district,
      local_level:
        postingData.physical_location_details.local_level.value ||
        postingData.physical_location_details.local_level,
      tole: postingData.physical_location_details.tole,
      ward: postingData.physical_location_details.ward
    };
    postingData.physical_location_details = postingPhysicalLocationData;
  }
  if (postingData.funded_departments) {
    postingData.alliance_partner = postingData.funded_departments;
  }
  postingData.output_number = postingData.output_number.value;

  delete postingData.data;
  delete postingData.localLevel_localLevels;
  delete postingData.localLevel_districts;
  delete postingData.targeted_prov_gov;
  delete postingData.local_gov_provinces;
  delete postingData.old_targeted_local_gov;
  delete postingData.events_physical_location_details;
  return postingData;
};
export const StyledCourseItem = styled.div`
  display: flex;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 1rem;
  padding: 0.5rem 0.5rem;
  .thumbnail_container {
    width: 100px;
    height: 100px;
    background-color: #e4e4e4;
    border-radius: 10px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  cursor: pointer;
  transition: transform 300ms, border 300ms;
  &.selected {
    border: 5px solid #1f60ba;
    transform: translateY(-5px);
    box-shadow: 0px 5px 5px 0px #b5b5b5;
  }
  .course-info {
    margin-left: 1rem;
  }
`;

export const CourseItemContainer = styled.div`
  height: 80vh;
  width: 100%;
  overflow-y: scroll;
`;

export const CourseLoading = styled.div`
  width: 100%;
  height: 50vh;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const CourseItem = ({ course, handleClick, isSelected, selectedCourses = [] }) => {
  let isCourseSelected =
    isSelected ||
    selectedCourses?.findIndex((linkedCourse) => linkedCourse?.id === course?.id) > -1;
  return (
    <StyledCourseItem
      className={`${isCourseSelected ? 'selected' : ''}`}
      onClick={() => {
        handleClick(course);
      }}>
      <div>
        <div className="thumbnail_container">
          <img
            src={course.thumbnail_image ? course.thumbnail_image : '/assets/images/placeholder.jpg'}
            alt={course.title}
          />
        </div>
      </div>
      <div className="course-info">
        <Heading4>{course.title}</Heading4>
      </div>
    </StyledCourseItem>
  );
};

function Step5() {
  const { actions } = useStateMachine({ updateAction, clearStore });
  const { state } = useStateMachine(updateAction);
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { eventId } = useParams();
  const navigator = useNavigate();
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (id) => {
    setShow(id);
  };
  const {
    handleSubmit,
    formState: { errors }
  } = useForm();

  const handleEventPost = async (data) => {
    try {
      setIsLoading(true);
      const response = await fetchWrapper.post('/event/', data);
      const event = response.data;
      handleShow(event.id);
      setIsLoading(false);
      actions.clearStore();
    } catch (error) {
      setIsLoading(false);
      console.log(errors, 'errors');
      ErrorMessageHandler(error);
    }
  };
  const handleEventPatch = async (data) => {
    try {
      setIsLoading(true);
      await fetchWrapper.patch(`/event/${eventId}/`, data);
      setIsLoading(false);
      toast.success('Event Updated Successfully');
      navigator(`/admin/events/${eventId}`);
      actions.clearStore();
    } catch (error) {
      setIsLoading(false);
      console.log(errors, 'errors');
      ErrorMessageHandler(error);
    }
  };
  const onSubmit = (data) => {
    actions.updateAction({
      event: {
        ...state.event,
        ...data
      }
    });
    let postingData = { ...state.event };
    postingData = postingDataGenerator(postingData);

    if (eventId) {
      handleEventPatch(postingData);
    } else {
      handleEventPost(postingData);
    }
  };

  const updateCourseLinks = (course) => {
    let tempLinkedCourses = [...(state.event.course_links || [])];
    let linkedCourseIndex = tempLinkedCourses.findIndex(
      (linkedCourse) => linkedCourse.id === course.id
    );
    if (linkedCourseIndex === -1) {
      let tempCourse = {
        title: course.title,
        id: course.id,
        slug: course.slug,
        created_by: course.created_by,
        thumbnail_image: course.thumbnail_image
      };
      tempLinkedCourses.push(tempCourse);
    } else {
      tempLinkedCourses.splice(linkedCourseIndex, 1);
    }
    actions.updateAction({
      event: {
        ...state.event,
        course_links: tempLinkedCourses
      }
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CourseAddition
        selectedCourses={state.event?.course_links}
        handleCourseClick={updateCourseLinks}
      />
      <PostEventCreatePrompt show={show} handleClose={handleClose} />
      <div>
        <hr />
        <NavigationButtonGroup isSubmit={true} isLoading={isLoading} backTo={'/admin/events'} />
      </div>
    </form>
  );
}

export default Step5;
